import { Box, Stack } from '@mui/material';
import { useEffect } from 'react';
import SuiTypography from '@upheal/design-system/components/legacy/Sui/SuiTypography';
import SuiButton from '@upheal/design-system/components/legacy/Sui/SuiButton';
import { Skeleton } from '@upheal/design-system/components/Skeleton/Skeleton';
import { ErrorState } from '@upheal/design-system/components/EmptyState/ErrorState';
import { loadVendorScript } from '../../../utils/vendorScript';
import './HubspotForm.css';
import { useQuery } from '@tanstack/react-query';
import { RiAlertLine } from '@remixicon/react';
import delay from 'delay';

declare global {
    interface Window {
        hbspt?: {
            forms: {
                create: (config: {
                    portalId: string;
                    formId: string;
                    target: string;
                    submitButtonClass?: string;
                    css?: string;
                }) => void;
            };
        };
    }
}

export const HubspotContactForm = (props: {
    onClose: (event: React.MouseEvent) => void;
}) => {
    const { onClose } = props;
    const {
        data: hubspot,
        isLoading,
        isError,
        isSuccess,
    } = useQuery({
        queryKey: ['hubspotScript'],
        queryFn: async () => {
            if (!window.hbspt) {
                await delay(2000);
                await loadVendorScript({
                    src: 'https://js.hsforms.net/forms/v2.js',
                    id: 'hubspot-forms-sdk',
                });
            }

            if (window.hbspt) {
                return window.hbspt;
            }

            throw new Error('Failed to load Hubspot forms script');
        },
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (hubspot) {
            hubspot.forms.create({
                portalId: '47735362',
                formId: '32d492a7-1ba8-4f6e-a558-1a9315788c65',
                target: '#hubspotForm',
                submitButtonClass: 'hs-button',
                css: '',
            });
        }
    }, [hubspot]);

    return (
        <Stack width="100%" p={4}>
            <Box pb={2}>
                <SuiTypography
                    variant="h3"
                    fontWeight="bold"
                    textAlign="center"
                >
                    Tell us more about your practice
                </SuiTypography>
            </Box>
            {isLoading ? (
                <Skeleton.Form />
            ) : isError ? (
                <ErrorState
                    icon={RiAlertLine}
                    title="Failed to load contact form"
                />
            ) : null}
            <Box id="hubspotForm" minHeight={isSuccess ? 500 : undefined} />
            <SuiButton variant="text" color="dark" onClick={onClose}>
                Close
            </SuiButton>
        </Stack>
    );
};
